import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    flexDir: 'row',
    justify: 'space-between',
    px: ['2', null, '0'],
    pb: '3',
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    flexDir: 'row',
    fontSize: ['sm', null, 'md'],
    fontWeight: 'bold',
    fontFamily: 'accent',
    color: 'white',
    textTransform: 'uppercase',
    pb: ['1', null, '0'],
    pl: '0',
    pr: ['1', null, '0'],
  },
  headerIconButton: {
    color: 'white',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {
    sx: {
      '.state-prior': { color: 'white' },
    },
  },
  headerVsBox: {
    color: 'beta.400',
    sx: {
      '+ *': {
        whiteSpace: 'unset',
      },
    },
  },
  bodyStack: {
    color: 'white',
    p: '0',
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    color: 'beta.500',
    h: '1.1em',
    ml: '2',
    mb: '0.5',
    w: 'auto',
  },
  scrollButtonGroup: {
    h: '10',
    variant: 'filter',
    boxShadow: 'none',
    w: 'full',
  },
  wrapperScrollSgm: {
    gap: '2',
    alignItems: 'center',
    display: 'flex',
    w: '100%',
    maxW: '100%',
  },
  toMarketButton: {
    sx: {
      '&[data-active]': {
        _after: {
          pos: 'relative',
          top: 'unset',
          right: '-2px',
        },
      },
    },
    _last: { mr: 2 },
  },
  toMarketButtonV2: {
    variant: 'tab',
    sx: {
      '&[data-active]': {
        color: 'beta.400',
        fontWeight: 'bold',
        borderBottom: '3px solid',
        borderBottomColor: 'beta.400',
      },
    },
    minW: 'fit-content',
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    pl: '1',
    pr: ['3', null, '1'],
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bgGradient: [
      'linear(to-b, alpha.100, alpha.400)',
      null,
      'linear(to-b, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.1))',
    ],
    border: 'none',
    borderRadius: 'md',
    boxShadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.11)',
    overflow: 'hidden',
  },
  accordionButton: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'accent',
    p: '2',
    mx: '1',
    w: '99%',
    pos: 'relative',
    textAlign: 'left',
    textTransform: 'uppercase',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      _after: { opacity: '1' },
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'white',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'white',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    p: '0',
  },
  cancelButton: {
    variant: 'solid',
    px: '3',
    border: 'none',
    bgGradient: 'linear(to-b, beta.300, beta.500)',
    boxShadow:
      '0px 3px 3px 0px rgba(0, 0, 0, 0.1), 0px 0px 0px 1px rgba(255, 255, 255, 0.3) inset',
    color: 'alpha.400',
    _hover: {
      bgGradient: 'linear(to-b, beta.400, beta.500)',
    },
  },
  clearButton: {
    variant: 'outline',
    color: 'black',
    ml: '3',
    px: '3',
    _hover: {
      borderColor: 'beta.300',
    },
  },
  countdown: {
    sx: {
      '&&&.state-prior': {
        textTransform: 'uppercase',
        p: 1,
        lineHeight: 'initial',
      },
    },
  },
  scrollButtonGroupV2: {
    variant: 'unstyled',
    flex: 1,
    position: 'relative',
    minH: '34px',
    w: ['270px', null, '660px'],
  },
  sgmLogoV2: {
    w: ['2em', '3em'],
  },
  sgmBtn: {
    sx: {
      px: ['1', null, '3'],
      'svg[class*="StyledIconBase"]': {
        w: '1.5em',
        h: '1.5em',
        color: 'white',
      },
    },
  },
  sgmBtnActive: {
    sx: {
      '&&': {
        px: '3',
        bg: 'blackAlpha.500',
        boxShadow:
          '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
      },
      svg: {
        w: '3em',
        color: 'beta.400',
      },
      'svg.chakra-icon': {
        filter: 'drop-shadow(0px 0px 8px rgba(37, 254, 214, 0.7))',
      },
      'svg[class*="StyledIconBase"]': {
        w: '1.5em',
        h: '1.5em',
        fill: 'beta.400',
        filter: 'none',
      },
    },
  },
};
